/** "9:00 AM" or "2:30 PM" in the user's local browser timezone */
export function formatTimeCT(isoDateTime: string): string {
  return new Date(isoDateTime).toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
}

/** HH:MM 24-hour in local timezone — for <input type="time"> */
export function formatTimeCTInput(isoDateTime: string): string {
  const str = new Date(isoDateTime).toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
  return str.startsWith('24') ? '00:' + str.slice(3) : str;
}

/** Convert a local-timezone HH:MM input + YYYY-MM-DD date back to a UTC ISO string */
export function ctInputToUTC(dateStr: string, localHHMM: string): string {
  const [h, m] = localHHMM.split(':').map(Number);
  // Temporarily treat the local time as UTC so we can measure the local offset
  const temp = new Date(
    `${dateStr}T${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:00Z`
  );
  const localStr = temp.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
  const localH = parseInt(localStr.startsWith('24') ? '0' : localStr.slice(0, 2));
  const localM = parseInt(localStr.slice(3, 5));
  const diffMin = (h * 60 + m) - (localH * 60 + localM);
  return new Date(temp.getTime() + diffMin * 60_000).toISOString().slice(0, 19) + 'Z';
}

/** "Mon, May 11" style */
export function formatDateLabel(dateStr: string): string {
  return new Date(dateStr + 'T00:00:00').toLocaleDateString('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  });
}

/** Short timezone abbreviation for the current browser, e.g. "CDT", "EST", "PST" */
export function localTZAbbr(): string {
  const parts = new Date().toLocaleTimeString('en-US', { timeZoneName: 'short' }).split(' ');
  return parts[parts.length - 1] ?? 'local';
}
